<template>
    <v-container
            class="fill-height"
            fluid
    >
        <v-row
                align="center"
                justify="end"
        >
            <v-col
                    cols="12"
                    sm="6"
                    md="5"
                    lg="3"
            >
                <v-card class="elevation-12">
                    <v-card-text style="padding-bottom: 0;">
                        <v-container>
                            <v-row class="header-image-container">
                                <v-col
                                        cols="12"
                                        sm="12"
                                        md="12"
                                >
                                    <v-img
                                            src="./../assets/logo.jpg"
                                            lazy-src="./../assets/logo.jpg"
                                            class="grey lighten-2"
                                            max-width="250"
                                    ></v-img>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <p class="text-justify font-weight-bold">
                                        {{ $t('registerUserExists.header') }}
                                    </p>
                                    <p class="text-justify">
                                        {{ $t('registerUserExists.text') }}
                                    </p>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-container style="padding-top: 0;">
                            <v-row
                            >
                                <v-col
                                        cols="12"
                                        sm="12"
                                        md="12"
                                >
                                    <v-btn x-large color="success" class="login-button"
                                           @click="redirectTo('login')">{{ $t("registerUserExists.login") }}
                                    </v-btn>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col
                                        cols="12"
                                        sm="12"
                                        md="12"
                                >
                                    <a @click="redirectTo('requestPasswordReset')" class="caption">
                                        {{ $t("registerUserExists.forgotPassword") }}
                                    </a>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: 'RegisterUserExists',
        created() {
            const email = this.$route.query.user;
            if(typeof email !== 'undefined') {
                this.email = email;
            }
        },
        methods: {
            redirectTo(route) {
                this.$router.push({
                    name: route,
                    query: {
                        user: this.email
                    }
                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .login-button {
        width: 100%;
        text-transform: initial;
    }

    .caption {
        text-decoration: underline;
    }

    .header-image-container {
        height: 75px;
    }
</style>
